import { StyledButton } from "../../components/styled/styled-components";
import { FetchedOrderUploadProduct } from "./types";
import { sortProducts } from "./utils/productUtils";
import CartItemTable from "../../components/CartItemTable/CartItemTable";
import Accordion from "../../components/Accordion/Accordion";
import { useOrderUploaderContext } from "./context/OrderUploaderContext";
import { productErrorCode } from "./utils/data";

const ImportTable = () => {
  const {
    fetchedProducts: products,
    handleRemoveItem: removeFetchedItem,
    handleReloadItem: reloadItemDetails,
  } = useOrderUploaderContext();
  const sortedProducts = sortProducts(products);
  const invalidProducts = sortedProducts.filter(
    (product: FetchedOrderUploadProduct) => !product.price || !product.itemNo,
  );
  const validProducts = sortProducts(
    sortedProducts.filter((product: FetchedOrderUploadProduct) => product.price && product.itemNo),
    {
      ascending: true,
      type: "index",
    },
  );

  return (
    <div className="import-table-container">
      {invalidProducts.length > 0 && (
        <Accordion title="Unimported Items" expanded>
          <table className="import-table">
            <tbody>
              {invalidProducts.map((product, index: number) => (
                <tr key={index} className="reload-order-item cart-item">
                  <td>
                    <StyledButton danger onClick={() => removeFetchedItem(product.csvLineArray[0])}>
                      Remove
                    </StyledButton>
                    <span style={{ margin: "0 8px" }}>or</span>
                    <StyledButton onClick={() => reloadItemDetails(product.csvLineArray[0])}>
                      Reload
                    </StyledButton>
                  </td>
                  <td>SKU: {product.csvLineArray[0]}</td>
                  <td>
                    {product.product_code &&
                      product.product_name &&
                      `Item: ${product.product_code} | Name: ${product.product_name}`}
                  </td>
                  {product.error_code && <td>Reason: {productErrorCode[product.error_code]}</td>}
                </tr>
              ))}
            </tbody>
          </table>
        </Accordion>
      )}
      <Accordion title="Imported Items" expanded>
        <CartItemTable items={validProducts} disableAvailableQty disableTotal />
      </Accordion>
    </div>
  );
};

export default ImportTable;
